import { WorkInProgress } from "~/components/ui";

export function HomePage() {
  return (
    <WorkInProgress headingLevel={1} className="mx-auto mt-8 sm:mt-12" />
  );
}
